// Derived entity. You should extend the base entity.
import Post from '@/models/posts/Post.js';

export default  class Bookmark extends Post {
  static entity = 'bookmark';
  // Call `super.fields()`` to merge fields.
  static fields() {
    return {
      ...super.fields(),
      bookmarkedAt: this.attr('bookmarkedAt'),
    };
  }
}
